var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 20.425V13.3228M19 25.6891V25.7516M27.9774 31.6666H10.0226C7.57008 31.6666 5.50038 30.0457 4.8492 27.8281C4.57123 26.8815 4.91278 25.8955 5.4352 25.056L14.4126 8.86821C16.5159 5.48826 21.4841 5.48827 23.5874 8.86821L32.5648 25.056C33.0872 25.8955 33.4288 26.8815 33.1508 27.8281C32.4996 30.0457 30.4299 31.6666 27.9774 31.6666Z",
    stroke: "#F6A723",
    strokeWidth: 3.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/Alert.d1694f32a1709f3d8bac3a6e3a6821e2.svg";
export { ForwardRef as ReactComponent };